import { ChangeDetectionStrategy, Component, computed } from '@angular/core';

interface CustomerLogo {
  alt: string;
  src: string;
  invertColors?: boolean;
}

@Component({
  selector: 'app-customer-logo-section',
  imports: [],
  templateUrl: './customer-logo-section.component.html',
  styleUrl: './customer-logo-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerLogoSectionComponent {
  private readonly allLogos: CustomerLogo[] = [
    {
      alt: 'AppGen',
      src: 'assets/images/logos/appgen.svg',
    },
    {
      alt: 'Body Tutor',
      src: 'assets/images/logos/body-tutor.png',
      invertColors: true,
    },
    {
      alt: 'BTC-ECHO',
      src: 'assets/images/logos/btc-echo.png',
    },
    {
      alt: 'Clovis',
      src: 'assets/images/logos/clovis.svg',
    },
    {
      alt: 'DHBW',
      src: 'assets/images/logos/dhbw.png',
    },
    {
      alt: 'Eyloo GmbH',
      src: 'assets/images/logos/eyloo.png',
    },
    {
      alt: 'snapADDY',
      src: 'assets/images/logos/snapaddy.svg',
    },
    {
      alt: 'Tapni',
      src: 'assets/images/logos/tapni.png',
    },
    {
      alt: 'NFC21 GmbH',
      src: 'assets/images/logos/nfc21.png',
      invertColors: true,
    },
    {
      alt: 'LLMBase',
      src: 'assets/images/logos/llmbase.svg',
    },
    {
      alt: 'Logistiko',
      src: 'assets/images/logos/logistiko.svg',
    },
    {
      alt: 'mobile function GmbH',
      src: 'assets/images/logos/mobile-function.svg',
    },
    {
      alt: 'Our Management Group',
      src: 'assets/images/logos/our-management-group.webp',
      invertColors: true,
    },
    {
      alt: 'Vitruve',
      src: 'assets/images/logos/vitruve.webp',
    },
    {
      alt: 'Vaow',
      src: 'assets/images/logos/vaow.webp',
    },
    {
      alt: 'Nuinalp',
      src: 'assets/images/logos/nuinalp.png',
    },
    {
      alt: 'AppScreens',
      src: 'assets/images/logos/appscreens.svg',
      invertColors: true,
    },
    {
      alt: 'TalkNotes',
      src: 'assets/images/logos/talknotes.svg',
    },
    {
      alt: 'OpenForge',
      src: 'assets/images/logos/openforge.png',
      invertColors: true,
    },
    {
      alt: 'Summon Worlds',
      src: 'assets/images/logos/summon-worlds.png',
    },
    {
      alt: 'SpeedPay',
      src: 'assets/images/logos/speedpay.svg',
    },
    {
      alt: 'Y Combinator',
      src: 'assets/images/logos/y-combinator.png',
    },
  ];

  readonly logos = computed(() => {
    return [...this.allLogos].sort(() => Math.random() - 0.5);
  });
}
